module.exports = __webpack_public_path__ + "svg/wave-on-dark.svg";